const state = () => ({
  moreOpen: false,
  accountOpen: false,
  importOpen: false,
  searchExpanded: false
});

const mutations = {
  setMoreOpen: (state, value) => {
    state.moreOpen = value;
  },
  setAccountOpen: (state, value) => {
    state.accountOpen = value;
  },
  setImportOpen: (state, value) => {
    state.importOpen = value;
  },
  setSearchExpanded: (state, value) => {
    state.searchExpanded = value;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
